'use client'

import { pushToGtmDataLayer } from '@/lib/tracking/services/tracking.gtm'
import { useEffect } from 'react'

type NotFoundTrackingProps = {
  search?: string
}

export function NotFoundTracking({ search }: NotFoundTrackingProps) {
  useEffect(() => {
    pushToGtmDataLayer({
      event: 'gaEvent',
      eventCategory: 'page zéro résultat de recherche',
      eventAction: 'univers',
      eventLabel: '',
    })
  }, [search])

  return null
}
